/* eslint-disable import/prefer-default-export */
import type { RootState } from '@src/store/reduxstore';

export const selectBotAccounts = (state: RootState) => state.botAccounts;

export const selectBotAccountsError = (state: RootState) =>
  state.botAccounts.error;

export const getBotButtons = (state: RootState) =>
  state.botAccounts.messaging.buttonsSettings;

export const getBotList = (state: RootState) =>
  state.botAccounts.messaging.interactiveListSettings;

export const selectBotAccountsRaw = (state: RootState) =>
  selectBotAccounts(state).data;
